module.exports = __webpack_public_path__ + "static/img/wine.c322488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wine.png
// module id = Sku9
// module chunks = 0